import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/helpdesk/org-settings")({
  component: OrgSettingsLayout,
});

function OrgSettingsLayout() {
  return <Outlet />;
}
